<template>
  <v-expansion-panel>
    <v-expansion-panel-header class="text-h6">Ontario</v-expansion-panel-header>
    <v-expansion-panel-content>
      <v-container fluid>
        <v-row>
          <v-col cols="12" sm="4">
            <account-picker v-model="ontario.mofPayableAccountRef" label="Ministry of Finance liability account"
                            :accounts="liabilityAccounts" :addTypes="['OtherCurrentLiability']"
                            hint="To accrue liabilities to the Ontario MOF"/>
          </v-col>
          <v-col cols="12" sm="4">
            <account-picker v-model="ontario.lcboPayableAccountRef" label="LCBO liability account"
                            :accounts="liabilityAccounts" :addTypes="['OtherCurrentLiability']"
                            hint="To accrue liabilities to the LCBO"/>
          </v-col>
          <v-col cols="12" sm="4">
            <account-picker v-model="ontario.hstPayableAccountRef" label="HST liability account"
                            :accounts="liabilityAccounts" :addTypes="['OtherCurrentLiability']"
                            hint="To accrue HST liabilities"/>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="4">
            <account-picker v-model="ontario.ontarioTaxesExpenseAccountRef" label="Taxes expense account"
                            :accounts="expenseAccounts" :addTypes="['Expense','OtherExpense','CostOfGoodsSold','Income']"
                            hint="To track taxes, markups, etc."/>
          </v-col>
        </v-row>
      </v-container>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
export default {
  name: 'QboAccounts',
  props: {
    accounts: {type:Array, required:true}
  },
  data() {
    return {
      ontario: {},
    }
  },
  computed: {
    liabilityAccounts() {
      return this.accounts.filter(account => account.type === 'OtherCurrentLiability');
    },
    expenseAccounts() {
      return this.accounts.filter(account => account.type === 'Expense' || account.type === 'OtherExpense' || account.type === 'CostOfGoodsSold' || account.type === 'Income');
    },
  },
  async created() {
    const results = await this.$apiCall(`query QboAccounts {
                                            ontarioPreferences {
                                              accrueInQBO,freightRate,lcboQuarterly,lcboDirectDeliveryFromDutyPaid,
                                              mofPayableAccountRef,lcboPayableAccountRef,hstPayableAccountRef,ontarioTaxesExpenseAccountRef
                                              lcboPaymentToId,mofPaymentToId,paymentMethodId,paymentAccountRef
                                              mofPaymentItemId,lcboPaymentItemId
                                              createReceipt
                                            }
                                          }`,
                                        {});
    if (!results.error)
      this.ontario = results.data.ontarioPreferences;
  },
  watch: {
    ontario: {
      async handler() {
        await this.$apiCall(`mutation QboAccounts($input:OntarioPreferencesInput!) {
                              ontarioSetPreferences(input:$input) {
                                accrueInQBO
                              }
                            }`,
                            {input:this.ontario});
      },
      immediate: false,
      deep: true
    }
  },
}
</script>